// extracted by mini-css-extract-plugin
export default {"listWrapper":"FilterCategories_listWrapper__ljGId","active":"FilterCategories_active__ixRpG"};